import React from "react";
import classNames from "classnames";
import BootstrapButtonGroup from "react-bootstrap/ButtonGroup";
import PropTypes from "prop-types";
import "./styles.scss";

const ButtonGroup = ({ children, className, fluid, ...rest }) => (
  <BootstrapButtonGroup
    className={classNames(
      "mydpd-btn-group",
      fluid && "mydpd-btn-group-fluid",
      className
    )}
    {...rest}
  >
    {children}
  </BootstrapButtonGroup>
);

ButtonGroup.propTypes = {
  ...BootstrapButtonGroup.propTypes,
  fluid: PropTypes.bool,
};

ButtonGroup.defaultProps = {
  fluid: false,
};

export default ButtonGroup;
